var DevProfileFakeData = [
    {
        id: 1,
        image: 'https://i.ibb.co/m6BksDy/pranto.jpg',
        devProfileTitle: 'Web Developer',
        devProfileDes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio accusantium magni eius molestiae ut nostrum?',
        facebookProfile: 'https://www.facebook.com/prantoshikder95/'
    },
    {
        id: 2,
        image: 'https://i.ibb.co/GJsCPCX/sayeed.jpg',
        devProfileTitle: 'Android Developer',
        devProfileDes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio accusantium magni eius molestiae ut nostrum?',
        facebookProfile: 'https://www.facebook.com/abu.sayeed.10690203'
    },
    {
        id: 3,
        image: 'https://i.ibb.co/nRDHM5F/sumi.jpg',
        devProfileTitle: 'Graphic Designer',
        devProfileDes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio accusantium magni eius molestiae ut nostrum?',
        facebookProfile: 'https://www.facebook.com/profile.php?id=100010348146723'
    },
    {
        id: 4,
        image: 'https://i.ibb.co/L83GZ32/masud.jpg',
        devProfileTitle: 'Digital Marketing',
        devProfileDes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio accusantium magni eius molestiae ut nostrum?',
        facebookProfile: 'https://www.facebook.com/mdabdullahal.masud.988'
    },
    {
        id: 5,
        image: 'https://i.ibb.co/K9zW9fV/abrar.jpg',
        devProfileTitle: 'Cyber Security',
        devProfileDes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio accusantium magni eius molestiae ut nostrum?',
        facebookProfile: 'https://www.facebook.com/abrar.zahin.54738'
    }
];

export default DevProfileFakeData;